<template>
	<v-row v-if="persons" align="start">
		<div class="text-left d-flex  px-3" style="flex-flow: wrap;">
			<v-autocomplete
				v-model="itemsSelected"
				:search-input.sync="searchPerson"
				:items="itemsAutocompletePersons"
				autocomplete="off"
				multiple
				outlined
				dense
				filled
				label="Seleccione"
				color="gray darken-2"
				small-chips
				placeholder="Seleccione"
				persistent-hint
				hint="Selecione personas"
				class="mr-2 my-2"
				style="width: 300px"
			>
				<template v-slot:selection="{ item }">
					<avatar
						:headline="false"
						class="ma-1"
						size="25"
						icon
						:name="item.firstName"
						:last-name="item.lastName"
						:url="item.avatar"
					/>
				</template>
			</v-autocomplete>
			<v-text-field
				v-model="filename"
				class="mr-2 my-2"
				dense
				outlined
				filled
				color="gray darken-2"
				persistent-hint
				hint="Nombre del documento"
				style="width: 300px"
				autocomplete="off"
			/>
			<v-text-field
				v-model="minTimeReading"
				class="mr-2 my-2"
				dense
				filled
				outlined
				color="gray darken-2"
				persistent-hint
				hint="Minutos de lectura"
				type="number"
				style="width: 120px"
				autocomplete="off"
			/>
			<div for="dateEndingPublications" style="width: 270px;">
				<input
					id="dateEndingPublications"
					class="input mt-2 filled"
					v-model="dateEndingPublications"
					persistent-hint
					hint="Minutos de lectura"
					type="datetime-local"
					style="width: 250px; height: 45%; background-color:#ffffff14;"
				/>
				<small style="font-size: 12px" class="text--secondary">
					Fecha de finalización
				</small>
			</div>
			<label class="uploadLabel d-flex mr-2 my-2" style="height: 0% !important;">
				<v-icon :color="file ? 'success' : 'orange darken-2'" left dark>
					mdi-cloud-upload
				</v-icon>
				<span class="body-2 text--secondary" style="min-width: 150px">
					{{ file ? 'Listo' : 'Seleccione archivo' }}
				</span>
				<v-file-input
					class="uploadButton"
					id="upload-doc"
					v-model="file"
					accept="application/pdf, video/mp4"
				>
				</v-file-input>
			</label>
			<v-btn
				color="info"
				class="body-2 text-capitalize py-4 ma-2 white--text"
				@click="onSubmit"
				small
				:disabled="disabled"
			>
				Agregar
			</v-btn>
			<span v-if="durationWarn" class="d-flex align-center red--text"
				>El video dura mas de 10 minutos</span
			>
		</div>
	</v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	components: {
		Avatar: () => import('@/components/ui/Avatar'),
	},
	data() {
		return {
			itemsSelected: [],
			file: null,
			dateEndingPublications: '',
			minTimeReading: 1,
			filename: '',
			searchPerson: '',
			headers: ['Personas', 'Nombre', 'Subir', 'Guardar'],
			loading: false,
			durationWarn: false,
		};
	},
	watch: {
		file(newVal) {
			if (newVal) {
				let video = document.createElement('video');
				video.preload = 'metadata';
				const vue = this;
				video.onloadedmetadata = function() {
					this.vue = vue;
					window.URL.revokeObjectURL(video.src);
					let duration = video.duration;
					if (duration > 600) {
						this.vue.file = null;
						this.vue.durationWarn = true;
					} else {
						this.vue.durationWarn = false;
					}
					newVal.duration = duration;
				};
				video.src = URL.createObjectURL(newVal);
			}
		},
	},
	computed: {
		itemsAutocompletePersons() {
			return this.persons.map(item => ({
				value: item._id,
				text: ` ${item.firstName.toUpperCase()} ${
					item.lastName ? item.lastName.toUpperCase() : ''
				} ${item.rut ? '[' + item.rut + ']' : ''}`,
				firstName: item.firstName,
				lastName: item.lastName,
				avatar: item.avatar,
			}));
		},
		disabled() {
			return !(this.itemsSelected.length && this.filename && this.file && !this.loading);
		},
		...mapGetters({
			persons: 'Person/persons',
		}),
	},
	methods: {
		async onSubmit() {
			this.loading = true;
			const payload = new FormData();
			payload.append('filename', this.filename);
			payload.append('minTimeReading', this.minTimeReading);
			payload.append('dateEndingPublications', this.dateEndingPublications);
			this.itemsSelected.forEach(person => {
				payload.append('persons[]', person);
			});

			payload.append('publications', this.file);

			await this.uploadPublications(payload);
			this.filename = '';
			this.minTimeReading = 1;
			this.dateEndingPublications = '';
			this.itemsSelected = [];
			this.file = null;
			this.loading = false;
		},
		...mapActions({
			uploadPublications: 'Person/uploadPublications',
		}),
	},
};
</script>

<style lang="scss" scoped>
.input {
	font: inherit;
	padding: 0.1em 0.5em;
	width: 100%;
	height: 100%;
	border-style: solid;
	border-color: grey;
	background: transparent;
	outline: none;
	font-size: 0.8rem;
	line-height: 1.4rem;
	border-radius: 4px;
	vertical-align: middle;
}
.uploadButton {
	display: none;
}
.uploadLabel {
	cursor: pointer;
	border: 1px solid gray;
	padding: 6px 14px;
	border-radius: 5px;
}
</style>
